import React, { useState } from 'react';
import { ProfileButton } from '@/components/@IntranetLibrary/GNB/GNBProfile/styles';
import { useAtomValue } from 'jotai';
import { MyInfoState } from '@/recoil/atom';
import { imgUrlChk } from '@/utils/function';
import MyMenuDrawer from '../../../MenuDrawer/MyMenuDrawer';
import { useGNBEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { GNBEventName } from '@/constant/gtm';
import ImageWithErrorHandling from '@/components/ImageWithErrorHandling';

const GNBProfile = () => {
  const { profileImageUrl, email, name } = useAtomValue(MyInfoState);
  const gnbEventTracker = useGNBEventTracker();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    gnbEventTracker(GNBEventName.clickProfile);
    setIsOpen(true);
  };
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <ProfileButton onClick={handleOpen}>
        <ImageWithErrorHandling
          src={imgUrlChk(profileImageUrl)}
          width={28}
          height={28}
          alt={'profile image'}
          errorImage={'/images/dummy/default-profile.svg'}
        />
      </ProfileButton>
      {email && <MyMenuDrawer isOpen={isOpen} onClose={handleClose} />}
    </>
  );
};

export default GNBProfile;
